import Vue from 'vue';
const { VUE_APP_ENV } = process.env;
// 从cookie中读取uid
const getCookie = (name) => {
    let arr,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
    } else {
        return null;
    }
};
function voxLog(options, userRole) {
    //调用方式[voxLog({}, "student") 第一参数如不增加,值全部默认. 第二参数为角色类型,如不增加默认为teacher.
    let pathName = window.location.pathname;
    let appName = pathName.split('/');
    let roleType = userRole || 'teacher';
    let where = options.where || 'vox_logs:web_' + roleType + '_logs';
    let tempObj = {
        userid: getCookie('uid'),
        auth: false, //typeof $uper === "undefined" ? false : $uper.userAuth, // 是否认证用户
        app: appName[1] || pathName,
        module: appName[1] || pathName,
        op: 'Load',
        subject: false, //typeof $uper === "undefined" ? false : $uper.subject.key,
        userAgent: window.navigator.userAgent,
        target: pathName,
        env: VUE_APP_ENV, //环境
    };
    Object.assign(tempObj, options);
    let url =
        '//log.17zuoye.cn/log?_c=' +
        where +
        '&_l=3&_log=' +
        encodeURIComponent(JSON.stringify(tempObj)) +
        '&_t=' +
        new Date().getTime();
    let logImage = document.createElement('img');
    logImage.style.display = 'none';
    logImage.src = url;
    logImage.setAttribute('data-html2canvas-ignore', true);
    document.getElementsByTagName('body')[0].appendChild(logImage);
    logImage.remove();
    return false;
}

function getWhere() {
    // 拿到入库的where
    let log_where_list = {
        parent: {
            android: 'app_17parent_android:normal',
            ios: 'app_17Parent_ios:normal',
            pc: 'vox_logs:parent',
            app: '17Parent',
        },
        teacher: {
            android: 'app_17teacher_android:normal',
            ios: 'app_17teacher_ios:normal',
            pc: 'vox_logs:web_teacher_logs', //logstash-web-teacher-logs-*
            app: '17Teacher',
        },
        student: {
            android: 'app_17homework_android:normal',
            ios: 'app_17homework_ios:normal',
            pc: 'vox_logs:web_student_logs',
            app: '17Student',
        },
        saas: {
            android: 'app_17saastea_android:normal',
            ios: 'app_17saastea_android:normal',
            pc: 'vox_logs:wechat_logs',
            app: 'YQSaasTeacher',
        },
        box: {
            android: 'app_17Pad_android:normal',
            ios: 'vox_logs:wechat_logs',
            pc: 'vox_logs:wechat_logs',
            app: '17zuoyeBox',
        },
        wx: {
            app: 'weixin',
            android: 'vox_logs:wechat_logs',
            ios: 'vox_logs:wechat_logs',
            pc: 'vox_logs:wechat_logs',
        },
    };
    let ua = window.navigator.userAgent;
    let pathName = window.location.pathname;
    let parent = /17Parent/i.test(ua) || /\/parent\//.test(pathName);
    let student = /17Student|17JuniorStu/i.test(ua) || /\/student\//.test(pathName);
    let teacher = /17Teacher|17JuniorTea/i.test(ua) || /\/teacher\//.test(pathName);
    let box = /17zuoyeBox/i.test(ua) || /\/teacher\//.test(pathName);
    let saas = /YQSaasTeacher/i.test(ua) || /\/teacher\//.test(pathName);

    // let isApp = /17Parent|17Student|17Teacher|17JuniorStu|17JuniorTea/i.test(ua);
    let iswx = /MicroMessenger/i.test(ua);
    let isIos = /ipad|iphone|ipod/i.test(ua);
    let isAndroid = /android/i.test(ua);
    if (iswx) {
        return log_where_list['wx'].pc;
    } else if (parent) {
        if (isIos) {
            return log_where_list['parent'].ios;
        } else if (isAndroid) {
            return log_where_list['parent'].android;
        } else {
            return log_where_list['parent'].pc;
        }
    } else if (student) {
        if (isIos) {
            return log_where_list['student'].ios;
        } else if (isAndroid) {
            return log_where_list['student'].android;
        } else {
            return log_where_list['student'].pc;
        }
    } else if (teacher) {
        if (isIos) {
            return log_where_list['teacher'].ios;
        } else if (isAndroid) {
            return log_where_list['teacher'].android;
        } else {
            return log_where_list['teacher'].pc;
        }
    } else if (box) {
        if (isIos) {
            return log_where_list['box'].ios;
        } else if (isAndroid) {
            return log_where_list['box'].android;
        } else {
            return log_where_list['box'].pc;
        }
    } else if (saas) {
        if (isIos) {
            return log_where_list['saas'].ios;
        } else if (isAndroid) {
            return log_where_list['saas'].android;
        } else {
            return log_where_list['saas'].pc;
        }
    }
}
function voxMegrezLog(options) {
    voxLog(
        Object.assign(options, {
            where: 'megrez:mirror-on-the-wall',
        }),
        ''
    );
}

function saasLog(options) {
    voxLog(
        Object.assign(options, {
            where: 'saas:p-delivery-cent-logs',
        })
    );
}

function doTrack(options) {
    voxLog(
        Object.assign(options, {
            where: getWhere(),
        }),
        ''
    );
}
doTrack.arr = function () {
    let arg = [...arguments];
    let etc = {};
    let options = {
        module: '',
        op: '',
        etc,
    };
    arg.forEach((item, index) => {
        if (index === 0) {
            options['module'] = item;
        } else if (index === 1) {
            options['op'] = item;
        } else {
            let key = 's' + (index - 2);
            etc[key] = item;
        }
    });
    voxLog(
        Object.assign(options, {
            where: getWhere(),
        }),
        ''
    );
};
//默认
Vue.prototype.doTrack = doTrack;
//根据需求自己扩展
Vue.prototype.voxMegrezLog = voxMegrezLog;

Vue.prototype.saasLog = saasLog;
